export default __webpack_public_path__ + "static/media/hht2_ep5_speaking_02.a6c54d2c.png";